import { Link } from 'react-router-dom'
import {ArrowLeft, SearchX} from 'lucide-react'
import Layout from '@/components/Layout'
import Container from '@/components/ui/Container'

function NotFound() {
  return (
    <Layout>
      <section className="flex min-h-[60vh] items-center py-20">
        <Container className="flex flex-col items-center text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-cyan-50 text-cyan-600">
            <SearchX className="h-8 w-8" aria-hidden="true" />
          </span>
          <h1 className="mt-6 text-4xl font-bold text-slate-900">404</h1>
          <p className="mt-3 text-lg font-semibold text-slate-800">Página não encontrada</p>
          <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-600">
            O conteúdo que você procura pode ter sido removido ou o endereço está incorreto. Volte para a página inicial e continue navegando.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 rounded-lg bg-cyan-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-cyan-500"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Voltar para a Home
          </Link>
        </Container>
      </section>
    </Layout>
  )
}

export default NotFound
